import { useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { useAction,useQuery } from 'convex/react';
import { api } from './convex/_generated/api';
//import { useAuth } from './contexts/AuthContext';
import { toast } from 'sonner';

const PACKS = [
  { id: "raise", title: "Ask for a Raise", price: "$9/mo", includes: ["Opening script (3 tones)", "What if they say no", "Follow-up email", "Negotiation lines", "Do/Don't checklist"], color: "#C8A96E", popular: true },
  { id: "manager", title: "Difficult Manager", price: "$9/mo", includes: ["Toxic boss confrontation", "Push back script", "Escalation email", "Paper trail language", "Exit interview lines"], color: "#E07A7A", popular: false },
  { id: "tenant", title: "Tenant Toolkit", price: "$9/mo", includes: ["Rent negotiation script", "Repair demand letter", "Deposit recovery email", "Lease dispute language", "Escalation ladder"], color: "#7A9EC8", popular: false },
  { id: "relationships", title: "Relationship Reset", price: "$9/mo", includes: ["Boundary-setting scripts", "Toxic person exit", "Family confrontation", "Cheating/lying confrontation", "Post-conflict repair"], color: "#9E7AC8", popular: false },
];

export default function PricingPage() {
  const [checkoutLoading, setCheckoutLoading] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const sessionId = location.state?.sessionId;
  //const sessionId = localStorage.getItem("session_id");
  //const { user } = useAuth();
  const createCheckout = useAction(api.stripe.createCheckoutSession);
  const createPortal = useAction(api.stripe.createPortalSession);
  const [error, setError] = useState(null);
  //const getUser = useQuery(api.users.getUserById);
  //const user= getUser({userId: sessionId});
  const user = useQuery(api.users.getUserBySession,
  sessionId ? { sessionId } : "skip"
);

if (user?.packRaise || user?.packManager || user?.packTenant || user?.packRelationships) {
      toast.success("You already have access!");
      localStorage.setItem('session_id', sessionId);
      navigate("/dashboard", { state: { sessionId } });
      return;
}

  const handleGetPack = async (packId) => {
    if (!sessionId) {
      toast.error("Please sign in first");
      navigate("/");
      return;
    }
    
    setCheckoutLoading(packId);
    try {
      const { url } = await createCheckout({
        userId: user._id,
        email: user.email,
        packId: packId
      });
      window.location.href = url;
    } catch (err) {
      toast.error("Failed to start checkout");
    } finally {
      setCheckoutLoading(null);
    }
  };

  const handleManage = async () => {
  setCheckoutLoading("portal");
  try {
    const { url } = await createPortal({ userId: user._id });
    window.location.href = url;
  } catch (err) {
    setError("Failed to open billing portal");
  } finally {
    setCheckoutLoading(null);
  }
};

  const isPro = user?.role === "pro";

  function userHasPack(user, packId) {
  if (packId === "raise" && user?.packRaise === true) return true;
  if (packId === "manager" && user?.packManager === true) return true;
  if (packId === "tenant" && user?.packTenant === true) return true;
  if (packId === "relationships" && user?.packRelationships === true) return true;
  return false;
}

  return (
    <section style={{ width:"1400px", margin: "0 auto", padding: "48px 24px", animation: "fadeUp 0.4s ease both" }}>
      <div style={{ textAlign: "center", marginBottom: 40 }}>
        <h2 style={S.sectionTitle}>High-Stakes Packs</h2>
        <p style={{ color: "#666", fontSize: 16 }}>Full playbooks for when it really matters</p>
        <p style={{ color: "#555", fontSize: 13, marginTop: 8 }}>All packs included in one Pro subscription — $9/mo</p>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(210px, 1fr))", gap: 20, marginBottom: 32 }}>
        {PACKS.map(pack => (
          <div key={pack.id} style={{
            ...S.packCard,
            borderColor: pack.popular ? pack.color : "#2a2a35",
            animation: pack.popular ? "glow 3s ease infinite" : "none",
          }}>
            {pack.popular && (
              <div style={{ position: "absolute", top: -12, left: "50%", transform: "translateX(-50%)", fontSize: 11, fontWeight: 700, color: "#0C0C0E", padding: "4px 14px", borderRadius: 20, background: pack.color, whiteSpace: "nowrap" }}>
                Most Popular
              </div>
            )}
            <div style={{ fontSize: 22, color: pack.color, marginBottom: 12 }}>✦</div>
            <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: 19, fontWeight: 700, color: "#F0F0F5", marginBottom: 6 }}>
              {pack.title}
            </h3>
            <div style={{ fontSize: 28, fontWeight: 700, fontFamily: "'Playfair Display', serif", color: pack.color, marginBottom: 20 }}>
              {pack.price}
            </div>
            <div style={{ marginBottom: 24 }}>
              {pack.includes.map((item, i) => (
                <div key={i} style={{ fontSize: 13, color: "#666", padding: "6px 0", borderBottom: "1px solid #1a1a22" }}>
                  ✓ {item}
                </div>
              ))}
            </div>
            {userHasPack(user, pack.id) ? (
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                    <div style={{ fontSize: 12, color: "#4a9a6a", textAlign: "center", padding: "8px", background: "#0F1A12", borderRadius: 8, border: "1px solid #2a4a30" }}>
                    ✓ Active
                    </div>
                    <button
                    onClick={() => handleManage()}
                    style={{ width: "100%", border: "1px solid #E07A7A", borderRadius: 10, padding: "12px", fontSize: 14, fontWeight: 600, color: "#E07A7A", cursor: "pointer", fontFamily: "'DM Sans', sans-serif", background: "transparent" }}>
                    Cancel Subscription
                    </button>
            </div>
                ) : (
                <button
                    onClick={() => handleGetPack(pack.id)}
                    style={{ width: "100%", border: "none", borderRadius: 10, padding: "12px", fontSize: 14, fontWeight: 600, color: "#0C0C0E", cursor: "pointer", fontFamily: "'DM Sans', sans-serif", background: pack.color }}>
                    Get This Pack
                </button>
                )}
          </div>
        ))}
      </div>

      <button
        onClick={() => navigate("/dashboard", { state: { sessionId } })}
        style={{ display: "block", margin: "0 auto", background: "none", border: "none", color: "#555", cursor: "pointer", fontSize: 14, fontFamily: "'DM Sans', sans-serif" }}
      >
        ← Back to generator
      </button>
    </section>
  );
}

const S = {
  sectionTitle: { fontFamily: "'Playfair Display', serif", fontSize: 34, fontWeight: 700, color: "#F0F0F5", marginBottom: 10 },
  packCard: { background: "#13131A", border: "1px solid #1E1E28", borderRadius: 16, padding: "28px 24px", position: "relative" },
};